
export const getSpeakers = (state) => {

    function fixTag(tagObj) {
        if (!tagObj) {
            return
        }
        let tag = "";
        if (tagObj.org) {
            tag = tagObj.org;
        } else {
            tag = tagObj;
        }
        tag = tag.replace(/\./g, "");
        tag = tag.replace(/ & /g, "-");
        tag = tag.replace(/ /g, "-");
        tag = tag.replace(/#/g, " ");
        return tag;
    }


    let array = []
    const speakers = state.speakers.map(speaker => {
        let speakerSessionTags = []

        const updatedSessions = speaker.speakerSession.map(speakerSession => {

            const matchedSession = state.sessions.find(session => session._id == speakerSession.sId);


            // Om en matchning hittas, uppdatera session-informationen
            if (matchedSession) {
                speakerSessionTags.push(fixTag(matchedSession.sessionTags[0]))
                return {
                    ...speakerSession,
                    sessionDescription: matchedSession.sessionDescription,
                    sessionKeyTakeAway1: matchedSession.sessionKeyTakeAway1,
                    sessionKeyTakeAway2: matchedSession.sessionKeyTakeAway2,
                    sessionKeyTakeAway3: matchedSession.sessionKeyTakeAway3,
                    sessionTagMain: matchedSession.sessionTagMain,
                };
            }

            return speakerSession;
        });



        /* 
        
                let tag = [fixTag(speakerSessionTags[0])]
        
                array.push(fixTag(speakerSessionTags[0])) */

        speaker.speakerSessionTags = speakerSessionTags


        return {
            ...speaker,
            speakerSession: updatedSessions
        };
    });




    return speakers
}

export const getSpeaker = (state) => (speakerUrl) => {
    return state.speakers.find(session => session.speakerURL === speakerUrl)
}
export const getSessions = (state) => {
    return state.sessions;
}

export const getAll = (state) => {

    return state.all;
}
export const getRooms = (state) => {

    if (state.all.rooms) {
        return state.all.rooms

    }

    return false

}
export const getTracks = (state) => {
    return state.tracks;
}
export const getSession = (state) => (sessionURL) => {
    return state.sessions.find(session => session.sessionURL === sessionURL)
}
export const getSessionID = (state) => (id) => {

    return state.sessions.find(session => session._id == id)
}
export const getSpeakerImageBySession = (state) => (sessionID) => {


    for (const speaker of state.speakers) {

        const sessionSpeaker = speaker.speakerSession.find(session => session.sId == sessionID)

        if (sessionSpeaker) {
            console.log('%c 🙈', 'color: #007acc;', speaker.speakerImageURL);

            return speaker.speakerImageURL

        }


    }



}

export const getEffect = (state) => {

    return state.effect;
}



// WEBPACK FOOTER //
// ./src/store/getters.js